import { render, staticRenderFns } from "./edit2.vue?vue&type=template&id=2a75f169&scoped=true&"
import script from "./edit2.vue?vue&type=script&lang=js&"
export * from "./edit2.vue?vue&type=script&lang=js&"
import style0 from "./edit2.vue?vue&type=style&index=0&id=2a75f169&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a75f169",
  null
  
)

export default component.exports